import React from 'react';
import { Box, Button } from '@mui/material';
import TableViewIcon from '@mui/icons-material/TableView';
import { exportToXLSX } from '../utils/exportArchives';

interface ExportButtonsProps {
  data: any[] | Record<string, any[]>;
  title: string;
}

const ExportButtons: React.FC<ExportButtonsProps> = ({ data, title }) => {
  return (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
      <Button
        variant="outlined"
        color="success"
        startIcon={<TableViewIcon />}
        onClick={() => exportToXLSX(data, title)}
        size="small"
      >
        Excel
      </Button>
    </Box>
  );
};

export default ExportButtons;
